import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardWarehouseRoutes = [
	{
		key: "reward-warehouse-orders",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/warehouse/orders/list`,
		component: React.lazy(() => import("views/reward-views/warehouse/orders/pages/WarehouseOrderView")),
	},
	{
		key: "reward-warehouse-orders-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/warehouse/orders/detail/:id`,
		component: React.lazy(() => import("views/reward-views/warehouse/orders/pages/WarehouseOrderDetail")),
	},
	{
		key: "reward-warehouse-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/warehouse/list`,
		component: React.lazy(() => import("views/reward-views/warehouse/warehouse-info/pages/WarehouseList")),
	},
];
